import { watch } from "vue"

import { configDestinos } from "@/utils/destinosConfig"

export function useCotizadorWatchers({

  destino,

  dias,
  dias1,
  dias2,

  sinVuelo

}) {

  watch(destino, (nuevoDestino) => {

    dias.value = ""

    const config =
      configDestinos[nuevoDestino]

    if (config?.tipo === "combinado") {

      dias1.value = config.min1
      dias2.value = config.min2

    } else {

      dias1.value = 1
      dias2.value = 1

    }

  })

  watch(sinVuelo, (val) => {

    if (
      val &&
      destino.value === "DECAMERON"
    ) {

      destino.value = "CTG"

    }

  })

}